import { useTranslation } from 'react-i18next'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import { banners } from '@widgets/personal/history/lib/constants'

import { URL_PAGE_LOYALTY } from '@shared/contants'
import { LocalizedLink as Link } from '@shared/lib/locale'
import Wrapper from '@shared/ui/wrapper'

import { Banner } from './Banner'
import { BonusList } from './BonusList'
import { TokenAccountsList } from './TokenAccountsList'

import styles from './styles.module.scss'



export default function PersonalHistory () {
  const { t: tn } = useTranslation('personal')
  const isTablet = useMediaQuery('(max-width: 1280px)')

  return (
    <Wrapper className={styles.root}>
      <h2 className={styles.root__title}> {tn('history.title')}</h2>
      <div className={styles.root__content}>
        <BonusList />
      </div>
      <div className={styles.root__sidebar}>
        <TokenAccountsList />
        
        {/* Loyalty program terms banners */}
        <div className={styles.root__banners}>
          {isTablet ? (
            <Swiper
              className={styles.swiper}
              spaceBetween={8}
              breakpoints={{
                768: {
                  spaceBetween: 16,
                },
              }}
              slidesPerView={'auto'}
            >
              {banners.map((el, i) => (
                <SwiperSlide
                  className={styles.slide}
                  key={`${el.description}-${i}`}
                >
                  <Banner title={tn(el.title)} description={tn(el.description)} />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            banners.map((el, i) => (
              <Banner
                key={`${el.description}-${i}`}
                title={tn(el.title)}
                description={tn(el.description)}
              />
            ))
          )}
        </div>
        
        <p className={styles.root__loyaltyLink}>
          <Link to={URL_PAGE_LOYALTY}>{tn('history.loyalty')}</Link>
        </p>
      </div>
    </Wrapper>
  )
}